module.exports = __webpack_public_path__ + "static/img/js2.dbaa646.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/course/js2.png
// module id = vFIb
// module chunks = 0